import { NgModule } from '@angular/core';
import { InputDirective } from '@directives/input.directive';
import { CustomInputDirective } from './custom-input.directive';
import { InputNumberDirective } from './input-number.directive';
import { TabDirective } from './mat-autocomplete.directive';
import { FancyboxDirective } from './fancybox.directive';
import { FormControlUppercaseDirective } from './formControl-Uppercase.directive';
// import { AppUppercaseInputDirective } from './input-uppercase.directive';

@NgModule({
    exports: [
        InputDirective,
        InputNumberDirective,
        TabDirective,
        CustomInputDirective,
        // AppUppercaseInputDirective,
        FancyboxDirective,
        FormControlUppercaseDirective
    ],
    declarations: [ 
        InputDirective, 
        InputNumberDirective,
        TabDirective,
        CustomInputDirective,
        // AppUppercaseInputDirective,
        FancyboxDirective,
        FormControlUppercaseDirective
    ]
})
export class DirectiveModule { }
